import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { AuthContext } from "../../../context/AuthContext";
import { useShareFiado } from "../../../hooks/useShareFiado";
import { usePhoneFormat } from "../../../hooks/usePhoneFormat";
import * as Yup from 'yup';

export function useLogin() {
  const { loginStatus } = useContext(AuthContext);
  const { typingPhoneNumber, formatNumberToNationalWithoutSpaces, validateLocalPhone, getCountryCode } = usePhoneFormat();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+52");
  const route = useNavigate();

  const validate = Yup.object({
    phoneNumber: Yup.number().typeError('Ingrese un número de celular válido')
    .required('Número de celular requerido')
    .test('Validate Phone Number','Ingrese un número de celular válido',value=> validateLocalPhone('+'+value) == true),
  })



  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    onSubmit: async (values) => {
      const res = await loginStatus(values.phoneNumber);
      if (res.status == "OTP_COMPLETED") {
        route("/SignInScreen", {
          state: {
            screen: "login",
            phoneNumber: values.phoneNumber
          },
        });
      }

      if (res.status == "OTP_PENDING") {
        route("/SignUpOTPScreen", {
          state: {
            screen: "login",
            phoneNumber: values.phoneNumber,
          },
        });
      }

      if (res.status == "PHONE_NUMBER_DOES_NOT_EXIST") {
        route("/SignUpScreen", {
          state: { phoneNumber: values.phoneNumber },
        });
      }
    },
    validationSchema: validate
  });

  return {
    formik,
    phoneNumber, setPhoneNumber,
    countryCode, setCountryCode
  }
}